import styled from 'styled-components';

export const StoreSnackbarIcon = styled.svg`
  left: 1.8125rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;
